import React from "react";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { LIBRARY_PATH, MAIN_PATH, MY_PUZZLES_PATH } from "../routes";
import { getHomePremium, homePremiumNavBarSx } from "../styles/homePremiumStyles";
import { slidingSafeAreaBottom } from "../styles/mainStyles";

const NAV_ITEMS = [
    { label: "Home", path: MAIN_PATH, exact: true, Icon: HomeOutlinedIcon },
    { label: "Library", path: LIBRARY_PATH, exact: false, Icon: CollectionsBookmarkOutlinedIcon },
    { label: "My Puzzles", path: MY_PUZZLES_PATH, exact: false, Icon: FolderOutlinedIcon },
];

function isNavActive(pathname, path, exact) {
    if (exact) {
        return pathname === path;
    }
    return pathname === path || pathname.startsWith(`${path}/`);
}

/** Tab bar — white in light mode, deep navy in dark; teal active. */
export default function BottomNav() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isDark } = useSlidingAppearance();
    const home = getHomePremium(isDark);

    return (
        <Box
            role="navigation"
            aria-label="Sliding Puzzle Quest"
            sx={{
                display: "flex",
                alignItems: "stretch",
                justifyContent: "space-around",
                width: "100%",
                ...homePremiumNavBarSx(isDark),
                boxSizing: "border-box",
                pt: 0.5,
                pb: `max(${slidingSafeAreaBottom}, 4px)`,
            }}
        >
            {NAV_ITEMS.map(({ label, path, exact, Icon }) => {
                const active = isNavActive(pathname, path, exact);
                const color = active ? home.teal : home.navInactive;
                return (
                    <Button
                        key={path}
                        type="button"
                        aria-label={label}
                        onClick={() => {
                            if (!active) navigate(path);
                        }}
                        aria-current={active ? "page" : undefined}
                        sx={{
                            flex: 1,
                            flexDirection: "column",
                            gap: 0.35,
                            pt: 0.5,
                            pb: 0.35,
                            px: 0.5,
                            minHeight: 52,
                            minWidth: 64,
                            borderRadius: 0,
                            textTransform: "none",
                            color,
                            fontFamily:
                                '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif',
                            "&:hover": {
                                bgcolor: "transparent",
                            },
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 44,
                                height: 28,
                                borderRadius: "14px",
                                bgcolor: active ? home.tealSoft : "transparent",
                            }}
                        >
                            <Icon sx={{ fontSize: 22, color: "inherit" }} />
                        </Box>
                        <Typography
                            component="span"
                            sx={{
                                fontSize: "0.625rem",
                                fontWeight: active ? 700 : 500,
                                lineHeight: 1.2,
                                letterSpacing: "0.01em",
                                color: "inherit",
                            }}
                        >
                            {label}
                        </Typography>
                    </Button>
                );
            })}
        </Box>
    );
}
